import { orderXClient } from '@/service/client'
import {
  ConfirmExecutionPlanResponse,
  DraftExecutionPlan,
  ServerMessage,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function confirmExecutionPlan(
  draft: DraftExecutionPlan
): Promise<ConfirmExecutionPlanResponse> {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      confirmExecutionPlan: {
        executionPlan: draft,
      },
    })
    return data.confirmExecutionPlanResponse as ConfirmExecutionPlanResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
